export enum OrderStatus {
  Pending = 1,
  InTransit = 2,
  OutForDelivery = 3,
  Delivered = 4,
  Expired = 5,
  FailedAttempt = 6,
  Exception = 7,
  InfoReceived = 8,
  ReadyForPickup = 9,
}
export enum SubStatus {
  // Pending
  Fulfilled = 1001,
  Unfulfilled = 1002,

  // InTransit
  InTransit = 2001,
  PickedUpByTheCarrier = 2002,
  ArrivedAtTheSortingFacility = 2003,
  CustomsClearanceCompleted = 2004,
  DepartedFromTheAirport = 2005,
  ArrivedAtTheDestinationCountry = 2006,
  ArrivedAtTheLocalFacility = 2007,

  // Out for delivery
  OutForDelivery = 3001,
  ContactedBeforeFinalDelivery = 3002,

  // Delivered
  Delivered = 4001,
  PickedUpByTheCustomer = 4002,
  SignedByCustomer = 4003,
  DeliveredToDoorstep = 4004,

  // Expired
  Expired = 5001,

  // FailedAttempt
  FailedAttempt = 6001,
  InvalidAddress = 6002,
  CustomerNotAvailable = 6003,
  FailedToContact = 6004,

  // Exception
  Exception = 7001,
  Unclaimed = 7002,
  RetainedByCustoms = 7003,
  ShipmentDamagedOrLost = 7004,
  ShipmentCancelled = 7005,
  RefusedByTheCustomer = 7006,
  ReturnedToSender = 7007,
  ReturningToSender = 7008,

  // Info received
  InfoReceived = 8001,

  // Ready for pickup
  ReadyForPickup = 9001
}

export const ShipmentsStatus: Record<OrderStatus, {
  name: string,
  color: string,
  translationKey: string,
}> = {
  [OrderStatus.Pending]: {
    name: "Pending",
    color: "#6D7175",
    translationKey: "Pending",
  },
  [OrderStatus.InTransit]: {
    name: "In Transit",
    color: "#1E93EB",
    translationKey: "InTransit",
  },
  [OrderStatus.OutForDelivery]: {
    name: "Out for Delivery",
    color: "#FCAF30",
    translationKey: "OutForDelivery",
  },
  [OrderStatus.Delivered]: {
    name: "Delivered",
    color: "#1BBE73",
    translationKey: "Delivered",
  },
  [OrderStatus.Expired]: {
    name: "Expired",
    color: "#BABEC3",
    translationKey: "Expired",
  },
  [OrderStatus.FailedAttempt]: {
    name: "Failed Attempt",
    color: "#8109FF",
    translationKey: "FailedAttempt",
  },
  [OrderStatus.Exception]: {
    name: "Exception",
    color: "#FD5749",
    translationKey: "Exception",
  },
  [OrderStatus.InfoReceived]: {
    name: "Info Received",
    color: "#00A0AC",
    translationKey: "InfoReceived",
  },
  [OrderStatus.ReadyForPickup]: {
    name: "Ready for pickup",
    color: "#EF8E20",
    translationKey: "ReadyForPickup",
  },
}

export const SubStatusData = {
  // Pending
  [SubStatus.Fulfilled]: {
    status: SubStatus.Fulfilled,
    il8nKey: "ShipmentSubStatus.Fulfilled",
  },
  [SubStatus.Unfulfilled]: {
    status: SubStatus.Unfulfilled,
    il8nKey: "ShipmentSubStatus.Unfulfilled",
  },

  // Transit
  [SubStatus.InTransit]: {
    status: SubStatus.InTransit,
    il8nKey: "ShipmentSubStatus.InTransit",
  },
  [SubStatus.PickedUpByTheCarrier]: {
    status: SubStatus.PickedUpByTheCarrier,
    il8nKey: "ShipmentSubStatus.PickedUpByTheCarrier",
  },
  [SubStatus.ArrivedAtTheSortingFacility]: {
    status: SubStatus.ArrivedAtTheSortingFacility,
    il8nKey: "ShipmentSubStatus.ArrivedAtTheSortingFacility",
  },
  [SubStatus.CustomsClearanceCompleted]: {
    status: SubStatus.CustomsClearanceCompleted,
    il8nKey: "ShipmentSubStatus.CustomsClearanceCompleted",
  },
  [SubStatus.DepartedFromTheAirport]: {
    status: SubStatus.DepartedFromTheAirport,
    il8nKey: "ShipmentSubStatus.DepartedFromTheAirport",
  },
  [SubStatus.ArrivedAtTheDestinationCountry]: {
    status: SubStatus.ArrivedAtTheDestinationCountry,
    il8nKey: "ShipmentSubStatus.ArrivedAtTheDestinationCountry",
  },
  [SubStatus.ArrivedAtTheLocalFacility]: {
    status: SubStatus.ArrivedAtTheLocalFacility,
    il8nKey: "ShipmentSubStatus.ArrivedAtTheLocalFacility",
  },

  // Out for delivery
  [SubStatus.OutForDelivery]: {
    status: SubStatus.OutForDelivery,
    il8nKey: "ShipmentSubStatus.OutForDelivery",
  },
  [SubStatus.ContactedBeforeFinalDelivery]: {
    status: SubStatus.ContactedBeforeFinalDelivery,
    il8nKey: "ShipmentSubStatus.ContactedBeforeFinalDelivery",
  },

  // Delivered
  [SubStatus.Delivered]: {
    status: SubStatus.Delivered,
    il8nKey: "ShipmentSubStatus.Delivered",
  },
  [SubStatus.PickedUpByTheCustomer]: {
    status: SubStatus.PickedUpByTheCustomer,
    il8nKey: "ShipmentSubStatus.PickedUpByTheCustomer",
  },
  [SubStatus.SignedByCustomer]: {
    status: SubStatus.SignedByCustomer,
    il8nKey: "ShipmentSubStatus.SignedByCustomer",
  },
  [SubStatus.DeliveredToDoorstep]: {
    status: SubStatus.DeliveredToDoorstep,
    il8nKey: "ShipmentSubStatus.DeliveredToDoorstep",
  },

  // Expired
  [SubStatus.Expired]: {
    status: SubStatus.Expired,
    il8nKey: "ShipmentSubStatus.Expired",
  },

  // FailedAttempt
  [SubStatus.FailedAttempt]: {
    status: SubStatus.FailedAttempt,
    il8nKey: "ShipmentSubStatus.FailedAttempt",
  },
  [SubStatus.InvalidAddress]: {
    status: SubStatus.InvalidAddress,
    il8nKey: "ShipmentSubStatus.InvalidAddress",
  },
  [SubStatus.CustomerNotAvailable]: {
    status: SubStatus.CustomerNotAvailable,
    il8nKey: "ShipmentSubStatus.CustomerNotAvailable",
  },
  [SubStatus.FailedToContact]: {
    status: SubStatus.FailedToContact,
    il8nKey: "ShipmentSubStatus.FailedToContact",
  },

  // Exception
  [SubStatus.Exception]: {
    status: SubStatus.Exception,
    il8nKey: "ShipmentSubStatus.Exception",
  },
  [SubStatus.Unclaimed]: {
    status: SubStatus.Unclaimed,
    il8nKey: "ShipmentSubStatus.Unclaimed",
  },
  [SubStatus.RetainedByCustoms]: {
    status: SubStatus.RetainedByCustoms,
    il8nKey: "ShipmentSubStatus.RetainedByCustoms",
  },
  [SubStatus.ShipmentDamagedOrLost]: {
    status: SubStatus.ShipmentDamagedOrLost,
    il8nKey: "ShipmentSubStatus.ShipmentDamagedOrLost",
  },
  [SubStatus.ShipmentCancelled]: {
    status: SubStatus.ShipmentCancelled,
    il8nKey: "ShipmentSubStatus.ShipmentCancelled",
  },
  [SubStatus.RefusedByTheCustomer]: {
    status: SubStatus.RefusedByTheCustomer,
    il8nKey: "ShipmentSubStatus.RefusedByTheCustomer",
  },
  [SubStatus.ReturnedToSender]: {
    status: SubStatus.ReturnedToSender,
    il8nKey: "ShipmentSubStatus.ReturnedToSender",
  },
  [SubStatus.ReturningToSender]: {
    status: SubStatus.ReturningToSender,
    il8nKey: "ShipmentSubStatus.ReturningToSender",
  },

  // Info received
  [SubStatus.InfoReceived]: {
    status: SubStatus.InfoReceived,
    il8nKey: "ShipmentSubStatus.InfoReceived",
  },

  // Ready for pickup
  [SubStatus.ReadyForPickup]: {
    status: SubStatus.ReadyForPickup,
    il8nKey: "ShipmentSubStatus.ReadyForPickup",
  },
}
